module.exports = __webpack_public_path__ + "static/media/supportButton.287b243a.svg";